var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0169 10.9339H10.8503V15.1006C10.8503 15.3216 10.7625 15.5336 10.6062 15.6899C10.4499 15.8462 10.2379 15.9339 10.0169 15.9339C9.79591 15.9339 9.58395 15.8462 9.42767 15.6899C9.27139 15.5336 9.18359 15.3216 9.18359 15.1006V10.9339H5.01693C4.79591 10.9339 4.58395 10.8461 4.42767 10.6899C4.27139 10.5336 4.18359 10.3216 4.18359 10.1006C4.18359 9.8796 4.27139 9.66764 4.42767 9.51136C4.58395 9.35508 4.79591 9.26728 5.01693 9.26728H9.18359V5.10061C9.18359 4.8796 9.27139 4.66764 9.42767 4.51136C9.58395 4.35508 9.79591 4.26728 10.0169 4.26728C10.2379 4.26728 10.4499 4.35508 10.6062 4.51136C10.7625 4.66764 10.8503 4.8796 10.8503 5.10061V9.26728H15.0169C15.2379 9.26728 15.4499 9.35508 15.6062 9.51136C15.7625 9.66764 15.8503 9.8796 15.8503 10.1006C15.8503 10.3216 15.7625 10.5336 15.6062 10.6899C15.4499 10.8461 15.2379 10.9339 15.0169 10.9339Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.33100ce311d30df052a53ca493770c13.svg";
export { ForwardRef as ReactComponent };